import styled, { css } from 'styled-components';

import { colors, spacing, mobileCssQuerist } from 'styles/theme';

export const SliderWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const SliderContainer = styled.div`
    position: relative;
    width: 100%;
    padding: ${spacing.medium} 0;
    touch-action: none;
    user-select: none;
`;

interface SliderTrackProps {
    $progress: number;
}

export const SliderTrack = styled.div<SliderTrackProps>`
    position: relative;
    width: 100%;
    height: 8px;
    border-radius: ${spacing.radiusXSmall};
    background: linear-gradient(
        to right,
        ${colors.pursuitGold} 0%,
        ${colors.pursuitGreen} 100%
    );
    cursor: pointer;
    touch-action: none;
`;

interface SliderHandleProps {
    $position: number;
    $isActive: boolean;
}

const getHandleColor = (position: number): string => {
    // Calculate color based on position (0-100%)
    // Interpolate through the gradient: grandGreen -> grandGold -> sunsetOrange
    if (position <= 50) {
        return colors.pursuitGold;
    } else {
        return colors.pursuitGreen;
    }
};

export const SliderHandle = styled.div<SliderHandleProps>`
    position: absolute;
    top: 50%;
    left: ${({ $position }) => $position}%;
    transform: translate(-50%, -50%);
    width: ${({ $isActive }) => ($isActive ? '32px' : '24px')};
    height: ${({ $isActive }) => ($isActive ? '32px' : '24px')};
    border-radius: 50%;
    background-color: ${colors.white};
    border: 3px solid ${({ $position }) => getHandleColor($position)};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    cursor: grab;
    transition: ${({ $isActive }) =>
        $isActive
            ? 'width 0.1s, height 0.1s, border-color 0.1s'
            : 'width 0.2s, height 0.2s, border-color 0.2s'};
    z-index: 2;
    touch-action: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:active {
        cursor: grabbing;
    }

    ${(props) =>
        mobileCssQuerist(css`
            width: ${props.$isActive ? '36px' : '28px'};
            height: ${props.$isActive ? '36px' : '28px'};
        `)}
`;

export const SliderTicks = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    pointer-events: none;
`;

interface SliderTickProps {
    $isActive: boolean;
}

export const SliderTick = styled.div<SliderTickProps>`
    width: 2px;
    height: ${({ $isActive }) => ($isActive ? '16px' : '12px')};
    background-color: ${({ $isActive }) =>
        $isActive ? colors.darkJungle : colors.grey30};
    border-radius: 1px;
    transition: height 0.2s, background-color 0.2s;
`;

export const SliderLabels = styled.div`
    margin-top: -${spacing.xxSmall};
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const SliderLabel = styled.span`
    font-size: 12px;
    color: ${colors.grey30};
    font-family: 'OpenSans-Regular';
`;
